import { withRouter } from 'react-router-dom'
import useCadastroOperacaoEstoque, { LOAD_MESSAGE } from './CadastroOperacaoEstoqueHook'
import { connect } from 'react-redux'
import { Badge, ConfirmDialog, CustomPanel, PageHeader, ThreeDots } from '../../../../components'
import React, { useEffect } from 'react'
import {
  hideLoadingBox,
  showLoadingBox,
  showMessageBox,
} from '../../../../store/actions/system.actions'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { tableCellCentered } from '../../../../assets/js/styles'
import * as colors from '../../../../assets/js/colors'
import ModalCadastroOperacaoEstoque from './ModalCadastroOperacaoEstoque/ModalCadastroOperacaoEstoque'
import { FaTrash } from 'react-icons/fa'

function CadastroOperacaoEstoque({ dispatch, history, selectedTp }) {
  const { state, localDispatch } = useCadastroOperacaoEstoque()

  useEffect(() => {
    localDispatch.onInit(selectedTp)
  }, [selectedTp])

  useEffect(() => {
    switch (state.loadingMessage) {
      case LOAD_MESSAGE.NONE:
        dispatch(hideLoadingBox())
        break
      case LOAD_MESSAGE.GET_OPERACOES:
        dispatch(showLoadingBox('Aguarde...', state.loadingMessage))
        localDispatch.getOperacoesEstoque(selectedTp)
        break
      case LOAD_MESSAGE.DELETE:
        dispatch(showLoadingBox('Aguarde...', state.loadingMessage))
        localDispatch.deleteOperacaoEstoque(selectedTp, state.selectedOperacao)
        break
      default:
        break
    }
  }, [state.loadingMessage])

  useEffect(() => {
    if (state.errorMessage) {
      dispatch(showMessageBox(null, state.errorMessage))
      localDispatch.resetState()
    }
  }, [state.errorMessage])

  return (
    <>
      <PageHeader>8.2 - Cadastro de Operação de Estoque</PageHeader>
      <div style={{ marginTop: 20 }}>
        <CustomPanel
          onNovo={() => localDispatch.toggleModal(true, null)}
          onVoltar={history.goBack}
          showBtnNovo={!!selectedTp}
        >
          <div className="p-grid" style={{ marginBottom: 20 }}>
            <div className="p-col-12">
              <DataTable
                value={state.operacoes_datatable}
                emptyMessage="Não existe operação para o período selecionado"
              >
                <Column
                  field="type"
                  header="Tipo"
                  style={tableCellCentered(200)}
                  body={operacao => (
                    <BadgeTypeOperacoesEstoque
                      status={
                        operacao.belongsToTransfer
                          ? `Transferência ${operacao.type}`
                          : operacao.type
                      }
                    />
                  )}
                />
                <Column field="name" header="Nome" />
                <Column field="grupo_de_operacao" header="Grupo" style={tableCellCentered(150)} />
                <Column
                  header="Aplicativo"
                  style={tableCellCentered(200)}
                  body={operacao => {
                    return operacao.entrada_aplicativo ? (
                      <Badge color={'#0b8a95'}>Sim</Badge>
                    ) : (
                      <Badge color="red">Não</Badge>
                    )
                  }}
                />
                <Column
                  header="Menu"
                  style={tableCellCentered(70)}
                  body={operacao =>
                    (operacao.type === 'Transferência' && (
                      <ThreeDots
                        items={['2. Ver Transferência', '3. Editar']}
                        onClick={item => localDispatch.onMenuItemClicked(item, operacao)}
                      />
                    )) || (
                      <ThreeDots
                        items={['3. Editar']}
                        onClick={item => localDispatch.onMenuItemClicked(item, operacao)}
                      />
                    )
                  }
                  bodyStyle={tableCellCentered()}
                />
                {localDispatch.verifyMenuItemAllowed({ id: 34, content: '1. Apagar' }) && (
                  <Column
                    header=""
                    style={tableCellCentered(70)}
                    body={operacao => (
                      <FaTrash
                        style={{ cursor: 'pointer' }}
                        color="red"
                        onClick={() => localDispatch.onMenuItemClicked('1. Apagar', operacao)}
                      />
                    )}
                    bodyStyle={tableCellCentered()}
                  />
                )}
              </DataTable>
            </div>
          </div>
        </CustomPanel>
      </div>
      <ModalCadastroOperacaoEstoque
        onModalSave={localDispatch.onModalSave}
        onError={error => dispatch(showMessageBox(null, error))}
        tpId={selectedTp}
        onModalClose={() => localDispatch.toggleModal(false, null)}
        selectedOperacao={state.selectedOperacao}
        visible={state.showModal}
        operacoesEntradaSaida={state.operacoes_entrada_saida}
      />
      <ConfirmDialog
        isVisible={state.modalConfirmDelete.show}
        title="Atenção"
        content={<span>Tem certeza que deseja excluir a operação de estoque?</span>}
        onCancelar={localDispatch.onModalDeleteClose}
        onOk={() => localDispatch.onModalDeleteSave(state.modalConfirmDelete.data)}
      />
    </>
  )
}

const mapStateToProps = ({ system: { selectedTp } }) => ({ selectedTp })
export default connect(mapStateToProps)(withRouter(CadastroOperacaoEstoque))

export function BadgeTypeOperacoesEstoque({ status }) {
  switch (status) {
    case 'Transferência Entrada':
      return <Badge color={colors.verde_hover}>{status}</Badge>
    case 'Transferência Saída':
      return <Badge color={colors.vermelho_hover}>{status}</Badge>
    case 'Entrada':
      return <Badge color={colors.verde}>{status}</Badge>
    case 'Saída':
      return <Badge color={colors.vermelho}>{status}</Badge>
    default:
      return <Badge color={colors.laranja}>Transferência</Badge>
  }
}
